import ekozAxios from './instance/axios';

export const createSetupIntent = () => ekozAxios.request({
  method: 'get',
  url: '/stripe/new_setup_intent.php',
});
